<template>
  <div class="home">
    <HelloWorld class="landing-padding" msg="¡Bienvenidos a Maxico!" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "LandingView",
  components: {
    HelloWorld,
  },
};
</script>

<style lang="scss">
.home {
  margin-top: 4rem;
  .landing-padding {
    margin-left: 1rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
}
</style>
